import Swiper, { Autoplay, EffectFade, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

export function initOilfinderBannerSwiper() {
    Swiper.use([Autoplay, EffectFade, Pagination]);

    document.querySelectorAll('.oilfinderBanner').forEach(banner => {
        const imageDelay = parseInt(banner.dataset.fadeImage, 10) || 5000;

        const container = banner.querySelector('.contentImage-swiper');
        if (!container) return;

        const wrapper = container.querySelector('.swiper-wrapper');
        const slides = wrapper.querySelectorAll('.swiper-slide');

        // Nur Swiper initialisieren, wenn mehr als ein Slide vorhanden ist
        if (slides.length <= 1) {
            return;
        }

        new Swiper(container, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            speed: 1000,
            autoplay: {
                delay: imageDelay,
                disableOnInteraction: false
            },
            allowTouchMove: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets'
            },
            navigation: false,
        });
    });
}
